import { styled } from '@mui/material/styles';
import { sharedHoverCardsStyles } from '../../../../sharedStyles/cardsStyles';

export const StyledFooterLocations = styled('div')(
  () => `
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
  `,
);

export const StyledFooterLocationsHeader = styled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    margin-bottom: ${theme.DS_spacing(['xs'])};
    
    ${theme.breakpoints.up('lg')} {
      margin-bottom: ${theme.DS_spacing(['md'])};
    }
  `,
);

export const StyledFooterLocationsList = styled('ul')(
  ({ theme }) => `
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    gap: ${theme.DS_spacing(['xs'])};
    
    ${theme.breakpoints.up('md')} {
      justify-content: center;
      max-width: 85%;
    }
    
    ${theme.breakpoints.up('lg')} {
      max-width: 100%;
    }
  `,
);

export const StyledFooterLocationsListItem = styled('li')(
  ({ theme }) => `
    display: flex;
  
    a {
      background: ${theme.DS_palette.background.light};
      padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['xs'])};
      border-radius: 24px;
      color: ${theme.DS_palette.buttons.enabled};
      font-size: 14px;
      font-weight: 700;
      line-height: 14px;
      
      &:hover {
        ${sharedHoverCardsStyles({ theme })};
        background: ${theme.DS_palette.background.light};
      }
    }
  `,
);

export const StyledFooterLocationsMoreLink = styled('li')(
  ({ theme }) => `
    a {
      color: ${theme.DS_palette.primary.black};
    }
  `,
);
